import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { GatewayDest, GatewayProvider } from 'react-gateway';
import { BbPopup } from '@browsbox-ui';
import ReactModal2 from 'react-modal2';
import { withNamespaces } from 'react-i18next';
import {
  DragLayer,
  BrowsboxDndContainer,
  BrowsboxMenuContainer,
  BrowsboxContentContainer,
  PreviewContainer,
  MessageContainer,
  SessionExpiredModal,
} from '../../components';
import initSessionTimer from '../../store/sessionActivity';
import BaseModuleContainer from '../../components/BaseModule/BaseModuleContainer';

const propTypes = {
  store: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

class RootContainer extends Component {
  componentDidMount() {
    initSessionTimer(this.props.store);
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <GatewayProvider>
          <div id="rootContainer">
            <BrowsboxDndContainer>
              <BrowsboxMenuContainer />
              <BrowsboxContentContainer />
              <DragLayer />
            </BrowsboxDndContainer>
            <PreviewContainer />
            <MessageContainer />
            <SessionExpiredModal />
            <BaseModuleContainer />
            <GatewayDest name="source-editor" className="o-editor-container" />
            <GatewayDest name="modal" className="o-bb-modal-container" />
            <GatewayDest name="popup" className="o-bb-popup-container" />
            <GatewayDest name="messages" className="o-bb-modal-container" />
          </div>
        </GatewayProvider>
      </Provider>
    );
  }
}

RootContainer.propTypes = propTypes;

// for ReactModal2 accessibility
ReactModal2.getApplicationElement = () => document.getElementById('rootContainer');
// for BbPopup accessibility
BbPopup.getApplicationElement = () => document.getElementById('rootContainer');

export default withNamespaces()(RootContainer);



// WEBPACK FOOTER //
// ./src/components/Root/RootContainer.prod.js